import { gql } from "@apollo/client";

import organizationTalentIndicatorFragment from "@apps/org-settings/graphql/organization-talent-indicator-fragment";

export default gql`
  ${organizationTalentIndicatorFragment}

  fragment ComplianceProgramAdminParticipantStatus on ParticipantStatusNode {
    oneononeStatus
    performanceAssessmentStatus
    performanceSelfAssessmentStatus
    managerAssessmentStatus
    managerSelfAssessmentStatus
    peerAssessmentStatus
    peerSelfAssessmentStatus
    meeting {
      id
      title
      meetingGroupId
    }
    user {
      id
      name
      email
      avatar
      managers(first: 1) {
        edges {
          node {
            id
            name
            avatar
          }
        }
      }
    }
  }

  query getComplianceProgramAdmin(
    $complianceProgramId: Int!
    $complianceProgramExists: Boolean!
    $organizationId: Int!
  ) {
    talentIndicators(organizationId: $organizationId) {
      edges {
        node {
          ...OrganizationTalentIndicator
        }
      }
    }
    complianceProgram(pk: $complianceProgramId)
      @include(if: $complianceProgramExists) {
      id
      title
      created
      updated
      dueDate
      startDate
      periodStartDate
      periodEndDate
      ongoing
      startDateOffset
      startDateDueDateOffset
      startDatePeriodStartOffset
      startDatePeriodEndOffset
      state
      recurrence
      calibration
      steps {
        step
        dueDateOffset
      }
      creator {
        id
        name
        avatar
        email
      }
      canUpdate {
        permission
        reason
      }
      canDelete {
        permission
        reason
      }
      canReadDetails {
        permission
        reason
      }
      appliesTo
      appliesToTeams {
        edges {
          node {
            id
            title
          }
        }
      }
      appliesToManagers {
        edges {
          node {
            id
            name
            avatar
          }
        }
      }
      appliesToUsers {
        edges {
          node {
            id
            name
            avatar
          }
        }
      }
      excludedUsers {
        edges {
          node {
            id
            name
            avatar
          }
        }
      }
      excludedHireDateAfter
      requiredTopicTemplates {
        edges {
          node {
            id
            title
          }
        }
      }
      scheduledReminders {
        edges {
          node {
            id
            message
            daysAfterStartDate
            sentDatetime
            slackNotification
            emailNotification
            nominations
            oneonone
            performanceAssessment
            performanceSelfAssessment
            peerAssessment
            managerAssessment
            engagementSurvey
          }
        }
      }
      performanceAssessmentTemplate {
        id
        assessmentType
        anonymity
        providers
        delivery
        hasSelfAssessment
        isOnlySelfAssessment
        questionSets {
          edges {
            node {
              id
              talentIndicatorQuestionSettings {
                title
                description
                talentIndicators {
                  talentIndicatorId
                  comment
                  responses
                  responseVisibility
                  description
                }
              }
            }
          }
        }
        enableRoleBasedAssessments
        enableGoalAssessments
        goalAssessmentScale
        goalAssessmentScaleLabels
        goalAssessmentScaleStartsAt
        goalAssessmentResponses
        roleBasedAssessmentsAssessNextRole
        roleBasedAssessmentsSelfAssessNextRole
        roleBasedAssessmentScale
        roleBasedAssessmentScaleLabels
        roleBasedAssessmentScaleStartsAt
        enableCoreValueAssessments
        coreValueAssessmentScale
        coreValueAssessmentScaleLabels
        coreValueAssessmentScaleStartsAt
        coreValueAssessmentResponses
        competencyAssessmentType
        nextRoleCompetencyAssessmentType
      }
      managerAssessmentTemplate {
        id
        assessmentType
        anonymity
        providers
        delivery
        hasSelfAssessment
        isOnlySelfAssessment
        questionSets {
          edges {
            node {
              id
              talentIndicatorQuestionSettings {
                title
                description
                talentIndicators {
                  talentIndicatorId
                  comment
                  responses
                  responseVisibility
                }
              }
            }
          }
        }
      }
      peerAssessmentTemplate {
        id
        assessmentType
        anonymity
        providers
        delivery
        hasSelfAssessment
        isOnlySelfAssessment
        questionSets {
          edges {
            node {
              id
              talentIndicatorQuestionSettings {
                title
                description
                talentIndicators {
                  talentIndicatorId
                  comment
                  responses
                  responseVisibility
                }
              }
            }
          }
        }
        enableRoleBasedAssessments
        enableGoalAssessments
        goalAssessmentScale
        goalAssessmentScaleLabels
        goalAssessmentScaleStartsAt
        goalAssessmentResponses
        roleBasedAssessmentsAssessNextRole
        roleBasedAssessmentsSelfAssessNextRole
        roleBasedAssessmentScale
        roleBasedAssessmentScaleLabels
        roleBasedAssessmentScaleStartsAt
        enableCoreValueAssessments
        coreValueAssessmentScale
        coreValueAssessmentScaleLabels
        coreValueAssessmentScaleStartsAt
        coreValueAssessmentResponses
        competencyAssessmentType
        nextRoleCompetencyAssessmentType
      }
      engagementSurveyTemplate {
        id
        assessmentType
        anonymity
        providers
        delivery
        questionSets {
          edges {
            node {
              id
              talentIndicatorQuestionSettings {
                title
                description
                talentIndicators {
                  talentIndicatorId
                  comment
                  responses
                  responseVisibility
                }
              }
            }
          }
        }
      }
      participantStatus {
        edges {
          node {
            ...ComplianceProgramAdminParticipantStatus
          }
        }
      }
    }
  }
`;
